import { getProficiencyLabel } from "./assessmentHelpers";
import S from "./Assessments.module.scss";

/** Competency score column */
const CompetencyScore = ({ latestScorePercent, latestTeamAveragePercent }) => {
  const label = getProficiencyLabel(latestScorePercent);
  const score = latestScorePercent != null ? Math.round(latestScorePercent) : null;
  const teamAvg = latestTeamAveragePercent != null ? Math.round(latestTeamAveragePercent) : null;

  return (
    <div className={S.competencyColumn}>
      <h4 className={S.competencyHeading}>
        <span className={S.competencyLabel}>Competency Score</span>
        {label && <span className="atlas-h3">{label}</span>}
      </h4>
      <div className={S.scoreRow}>
        {score != null && (
          <div>
            <span className={S.scoreValue} aria-label={`Your latest score: ${score} percent`}>
              {score}%
            </span>
            <div className={S.scoreLabel} aria-hidden="true">
              Your latest score
            </div>
          </div>
        )}
        {teamAvg != null && (
          <div>
            <span className={S.scoreValue} aria-label={`Latest team average: ${teamAvg} percent`}>
              {teamAvg}%
            </span>
            <div className={S.scoreLabel} aria-hidden="true">
              Latest team avg
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export { CompetencyScore };
